import PreSignupSponsor from './container'

export default PreSignupSponsor
